import request from '@/utils/request'

/**
 * 查询仓库列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryShopHouse(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopHouse.queryShopHouse',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 添加仓库
 * @param {Object} data 仓库数据
 * @returns {Promise} Promise对象
 */
export function saveShopHouse(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopHouse/saveShopHouse',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 修改仓库
 * @param {Object} data 仓库数据
 * @returns {Promise} Promise对象
 */
export function updateShopHouse(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopHouse/updateShopHouse',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(res.msg)
      }
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除仓库
 * @param {Object} data 仓库数据
 * @returns {Promise} Promise对象
 */
export function deleteShopHouse(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopHouse/deleteShopHouse',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(res.msg)
      }
    }).catch(error => {
      reject(error)
    })
  })
}